const TEMPLATE_NAME = 'EVALUATION_QUESTION_OPTION';
const initialState = () => ({
  loading: false,
  data: []
  // filter: {
  //     term: '',
  //     data: [],
  // },
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        data: newData,
        loading: false
        // filter: {
        //     ...state.filter,
        //     data: newData,
        // },
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
